<template>
    <app-elements
        sectionHandle="data"
        cardModel="horizontal"
        :categoryGroups="categoryGroups"
        :displayTextSearch="true"
        :options="{
            limit: 12
        }"
    >
        <template #cardContent="data">
            <div class="t-content">
                <h1 class="c-card__title">{{ data.title }}</h1>
                <p v-html="excerpt(data.description, 144)" />
            </div>
        </template>
    </app-elements>
</template>

<script>
import AppElements from "layout/AppElements";

import Tag from "objects/Tag";

import { SECTION_HANDLES } from "src/constants";

import { excerpt } from "src/utils";

export default {
    name: "BlockDataList",
    components: {
        AppElements,
        Tag
    },
    data: () => ({
        SECTION_HANDLES,
        categoryGroups: [
            {
                group: "subjects",
                label: "Sujets",
                type: "checkbox"
            }
        ]
    }),
    props: {
        data: false
    },
    methods: {
        excerpt
    }
};
</script>

<style lang="scss">
.b-data-list {
}
</style>
